<template>
  <div>
    <el-row
      :gutter="24"
      type="flex"
      justify="center"
      style="flex-wrap: wrap;"
    >
      <el-col
        v-for="(item, index) in data"
        :key="index"
        :lg="8"
        :span="12"
        class="mb-xl"
      >
        <el-card class="w-100 text-center">
          <h3 class="text-xl mb-xs">
            {{ item.name }}
          </h3>
          <h2 class="text-primary">
            {{ item.count | numberWithDelimiter }}
          </h2>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "DashboardStatistics",
  props: {
    data: Array
  }
};
</script>

<style lang="scss" scoped></style>
